// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"3e70caac1ac8c39f71fe","453":"fcd8c9da5af7af61a78f"}[chunkId] + ".js";
};